(function ($, Drupal, drupalSettings) {
    let _ = require('lodash');

    window.dataLayer = window.dataLayer || [];

    if (window.localStorage === undefined) {
        return;
    }

    const setDomListeners = () => {
        let form = document.getElementById('modal_request_form');
        let button = form.querySelector('.form-actions > button.form-submit');

        if (_.isNil(button)) {
            return;
        }

        window.localStorage.removeItem('request_form_data');

        button.addEventListener('click', (e) => {
            let amountSamples = form.querySelector('.form-item-amount-samples > select').value

            if (!amountSamples) {
                return;
            }

            let calculatedPrice = calculatePrice(amountSamples);
            let pricePerPiece = calculatedPrice / amountSamples;

            window.localStorage.setItem('request_form_data', JSON.stringify({
                'product_name': 'Lood-in-water test sample',
                'quantity': amountSamples,
                'price_per_piece': pricePerPiece,
                'total_price': calculatedPrice,
            }));
        })
    }

    const calculatePrice = (amount) => {
        let priceFirstSample = parseFloat(drupalSettings.ef2_custom.price_first_sample);
        let pricePerNextSample = parseFloat(drupalSettings.ef2_custom.price_per_next_sample);
        let shippingCosts = parseFloat(drupalSettings.ef2_custom.shipping_costs);

        let price = priceFirstSample + shippingCosts;

        if (amount > 1) {
            let samplesPrice = pricePerNextSample * (amount - 1);
            price = price + samplesPrice;
        }

        return price;
    }

    const checkRequestCompleted = () => {
        let packageRequestData = JSON.parse(window.localStorage.getItem('request_form_data'));

        if (window.location.pathname !== '/betaling-geslaagd' || !packageRequestData) {
            return;
        }

        window.dataLayer.push({
            'event': 'purchase',
            'ecommerce' : {
                'value': packageRequestData.total_price,
                'currency': "EUR",
                'items': [{
                    'item_name': packageRequestData.product_name,
                    'quantity': packageRequestData.quantity,
                    'price': packageRequestData.price_per_piece
                }]
            },
        })
        window.localStorage.removeItem('request_form_data')
    }

    checkRequestCompleted();

    Drupal.behaviors.requestForm = {
        attach: function (context, settings) {
            if (context.id && context.id === 'modal_request_form') {
                setDomListeners();
            }
        }
    }
})(jQuery, Drupal, drupalSettings);